import { render, staticRenderFns } from "./PlayerSelectors.vue?vue&type=template&id=28fd4ec7&scoped=true&"
import script from "./PlayerSelectors.vue?vue&type=script&lang=ts&"
export * from "./PlayerSelectors.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerSelectors.vue?vue&type=style&index=0&id=28fd4ec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd4ec7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
